import Button from '../../../../components/button'
import useToggle from '../../../../hooks/use-toggle'
import { H5, S05 } from '../../../../styles/typography'
import PricingStore from '../stores/pricing-store'
import InviteOthers from './invite-others'

const SendInvites = () => {
  const [showModal, toggleModal] = useToggle(false)

  const { existing } = PricingStore.useContainer()

  return !existing?.id ? null : (
    <div className='invites'>
      <div className='card'>
        <H5>Invite others to upgrade your subscription!</H5>

        <S05>
          You will get an <span>extra 30 days extension</span> in your
          subscription plan when any user you have invited purchases a LivDemy
          Subscription. <span>And there's no limit!</span> You'll get 1 month
          added to your plan for every successful purchase by your invite!
        </S05>

        <S05>
          To make the deal even sweeter, the person you invite also gets added
          benefits based on the plan they purchase. Purchasing a musician plan
          will get access to 1 live session for free, and purchasing the Maestro
          plan gets them an additional month added to their plan.
        </S05>

        <Button theme='primary' onClick={() => toggleModal(true)}>
          Invite Others
        </Button>

        {showModal && <InviteOthers close={() => toggleModal(false)} />}
      </div>
    </div>
  )
}

export default SendInvites
